import React, {Component} from "react";
import {Col, FormGroup, Nav, Row, Tab} from "react-bootstrap";
import InfoSelectCard from "../Cards/Card/InfoSelectCard";
import {capitalizeWords} from "../../lib/common";
import {Responsive, WidthProvider} from 'react-grid-layout';
import {layoutsProject} from "../../lib/gridLayouts";
import KnoaCheckbox from "./KnoaCheckbox";
import TimeframeSelection from "./TimeframeSelection";
import ReportApplicationfilters from "../Filter/ReportApplicationfilters";
import ReportUserfilters from "../Filter/ReportUserfilters";
import ReportParametersFilters from "../Filter/ReportParametersFilters";


const onLayoutChange = () => {
    setTimeout(function () {
        const event = document.createEvent("Event");
        event.initEvent("resize", false, true);
        window.dispatchEvent(event);
        //window.dispatchEvent(new Event('resize'))
    }, 200);
};

const GenerateNavItems = ({ data, handleClick, trans }) => {
    return (
        <Nav className="tabUL nav-icons" variant="tabs">
            {data.map((item, index) => (
                <Nav.Item key={index} className="tabText">
                    <Nav.Link eventKey={item.type} onClick={handleClick}>
                        <i className={`${item.icon} tabIcon`} /><br />
                        {trans('route.name:' + item.type.toLowerCase())}
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};

const GenerateSelectCards = props => {
    const {data, id, icon, handleProjectReportsUpdate, reportType, trans} = props;

    if (tabSelected) {
        ResponsiveGridLayout = WidthProvider(Responsive);
    }

    //Extract report name without Daily/Monthly for translation
    const _data = data.map(item => {
        let workbook = [];
        if (reportType === 'CURRENT') {
            workbook = item.workbookName.split(' Daily');
            item.reportName = workbook[0];
            item.reportType = 'daily';
        } else if (reportType === "HISTORICAL") {
            workbook = item.workbookName.split(' Monthly');
            item.reportName = workbook[0];
            item.reportType = 'monthly';
        }
        return item;
    });

    const items = _data.map((item, index) => (
        <div key={index + 1}>
            <InfoSelectCard
                key={index}
                id={id + ":" + item.id + ":" + reportType}
                isChecked={item.checked}
                icon={{
                    name: icon,
                    status: "neutral"
                }}
                subHeading={{
                    text: item.dualPeriod ? trans('common:dualPeriod') : trans('common:singlePeriod'),
                    color: "#595959"
                }}
                heading={{
                    text: trans('report.name:withTypeFirst', {reportName: capitalizeWords(item.reportName), type: item.reportType}),
                    color: "#000000"
                }}
                footerText={trans('kpiCard.footer:' + item.description)}
                handleProjectReportsUpdate={handleProjectReportsUpdate}
                mainRowHeight={"125px"}
            />
        </div>
    ));

    tabSelected = false;

    return (
        <ResponsiveGridLayout className="layout"
                              layouts={layoutsProject}
                              breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}}
                              cols={{lg: 6, md: 6, sm: 6, xs: 6, xxs: 2}}
                              isDraggable={false}
                              isResizable={false}
                              onLayoutChange={onLayoutChange}
        >
            {items}
        </ResponsiveGridLayout>
    )
};

const GenerateTabItems = props => {
    const {data, handleProjectReportsUpdate, reportType, trans} = props;

    return data.map((item, index) => (
        <Tab.Pane eventKey={item.type} key={index}>
            <GenerateSelectCards
                data={item.data}
                id={item.type}
                icon={item.icon}
                handleProjectReportsUpdate={handleProjectReportsUpdate}
                reportType={reportType}
                trans={trans}
            />
        </Tab.Pane>
    ));
};

let ResponsiveGridLayout = WidthProvider(Responsive);
let tabSelected = false;

class KnoaTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSelectedTab: props.data ? props.data[0].type : "Filters",
        };
        this.tabSelect = this.tabSelect.bind(this);
    }


    componentDidUpdate() {
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        if (scrollPosition) {
           // document.getElementById("nav-with-icons").scrollTo(0,parseInt(scrollPosition))
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem("scrollPosition");
        }
    }

    tabSelect = (key) => {
        tabSelected = true;
        this.setState({currentSelectedTab: key});

        //for project wizard report card tabs
        if(this.props.resetSelectAllCheckStatus) {
            this.props.resetSelectAllCheckStatus(this.props.reportType, key);
        }

        window.sessionStorage.setItem("scrollPosition", window.pageYOffset);
    }

    selectionForALL = (checked) => {
        this.props.selectAllHandler(this.props.reportType, checked, this.state.currentSelectedTab);
    }

    render() {
        const {
            data,
            controlId,
            handleProjectReportsUpdate,
            isSelectAllChecked,
            reportType,
            currentReportFilters,
            filterType,
            timeData,
            updateTimeFilterValues,
            updateApplicationsAndUserFilterValues,
            absoluteStartError,
            absoluteEndError,
            handleAuthorization401,
            updateParametersValues,
            parameterErrors,
            trans,
            workbookId,
            workbookName,
            setTempFilterChanged,
            isInstanceReport
        } = this.props;

        const filterProps = {
            filterType,
            timeFilter: { current: timeData, historical: timeData },
            handleTimeFilterUpdate: updateTimeFilterValues,
            context: 'filterPanel',
            isInstanceReport,
            absoluteStartError,
            absoluteEndError
        };

        const reportProps = {
            currentReportFilters,
            updateApplicationsAndUserFilterValues,
            handleAuthorization401,
            workbookId,
            workbookName,
            setTempFilterChanged,
            isInstanceReport
        };

        const showParametersTab =
            currentReportFilters &&
            Object.keys(currentReportFilters).length > 0 &&
            currentReportFilters.tableauParams?.length > 0;

        if (data && data.length > 0) {
            return (
                <Row className="knoaRow">
                    <FormGroup controlId={controlId}>
                        <Tab.Container id="nav-with-icons" defaultActiveKey={data[0].type} onSelect={this.tabSelect}>
                            <div className="nav-container">
                                <Row className="project-reports-tab-row">
                                    <Col md={12}>
                                        <GenerateNavItems data={data} trans={trans} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="checkbox-select-all-row-Col">
                                        <KnoaCheckbox
                                            isChecked={isSelectAllChecked}
                                            number={100}
                                            label={trans('common:selectAll')}
                                            inline="selectALL"
                                            handleSelectionForALL={this.selectionForALL}
                                        />
                                    </Col>
                                </Row>
                                <Tab.Content className="gridAdjustRight gridAdjustLeft knoa-tab-content">
                                    <GenerateTabItems
                                        data={data}
                                        handleProjectReportsUpdate={handleProjectReportsUpdate}
                                        reportType={reportType}
                                        trans={trans}
                                    />
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </FormGroup>
                </Row>
            );
        } else if (controlId === 'reportsFilterTabs') {
            return (
                <Row className="reportFilterTabs">
                    <FormGroup controlId={controlId} className="report-filter-tabs-form-group">
                        <Tab.Container
                            activeKey={this.state.currentSelectedTab ? this.state.currentSelectedTab : "Filters"}
                            onSelect={this.tabSelect}
                        >
                            <Row>
                                <Col md={12}>
                                    <Nav variant="tabs" id="reportTabs" className="filter-tabs">
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey="Filters"
                                                className={
                                                    !showParametersTab || this.state.currentSelectedTab === "Filters"
                                                        ? "disabled-tab"
                                                        : ""
                                                }
                                                onClick={(e) => {
                                                    if (!showParametersTab || this.state.currentSelectedTab === "Filters") {
                                                        e.preventDefault(); // prevent click if it's the only tab or already active
                                                    }
                                                }}
                                            >
                                                {trans('report.parameters:Filters')}
                                            </Nav.Link>
                                        </Nav.Item>

                                        {showParametersTab && (
                                            <Nav.Item>
                                                <Nav.Link
                                                    eventKey="Parameters"
                                                    className={this.state.currentSelectedTab === "Parameters" ? "disabled-tab" : ""}
                                                    onClick={(e) => {
                                                        if (this.state.currentSelectedTab === "Parameters") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    {trans('report.parameters:Parameters')}
                                                </Nav.Link>
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </Col>

                                <Col md={12}>
                                    <Tab.Content id="reportTabContents">
                                        <Tab.Pane eventKey="Filters">
                                            <div className="card card-filter-filters" id="filterPanelDiv">
                                                <Row className="card-filter-row">
                                                    <Col md={4}>
                                                        <TimeframeSelection {...filterProps} />
                                                    </Col>
                                                    <Col md={4}>
                                                        <ReportApplicationfilters {...reportProps} />
                                                    </Col>
                                                    <Col md={4}>
                                                        <ReportUserfilters {...reportProps} />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Tab.Pane>

                                        {showParametersTab && (
                                            <Tab.Pane eventKey="Parameters">
                                                <div className="card card-filter-parameters">
                                                    <Row className="card-filter-row-report-panel">
                                                        <Col md={12} className="card-filter-parameters-col">
                                                            <ReportParametersFilters
                                                                currentReportFilters={currentReportFilters}
                                                                isInstanceReport={isInstanceReport}
                                                                updateParametersValues={updateParametersValues}
                                                                parameterErrors={parameterErrors}
                                                                workbookId={workbookId}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab.Pane>
                                        )}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </FormGroup>
                </Row>
            );
        }
        return null;
    }
}

export default KnoaTab;